import { createRoot } from 'react-dom/client';
import Kosmate from './kosmate';

// Importing the Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Kosmate />);
